import {Component, NgZone, OnInit, Optional, ViewChild} from '@angular/core';
import {AnimationOptions} from "ngx-lottie";
import {CommonService} from "./shared/service/common.service";
import {SplashScreen} from "@capacitor/splash-screen";
import {LanguageService} from "./shared/service/language.service";
import {StatusBar, Style} from "@capacitor/status-bar";
import * as moment from "moment";
import {slideTransition} from "./shared/animation";
import {FirebaseService} from "./shared/service/firebase.service";
import {IonRouterOutlet, MenuController, ModalController, NavController, Platform} from "@ionic/angular";
import {DrawerModalComponent} from "./shared/components/drawer-modal/drawer-modal.component";
import {App, URLOpenListenerEvent} from "@capacitor/app";
import {ActivatedRoute, NavigationEnd, Router} from "@angular/router";
import {filter} from "rxjs";
import {OnesignalService} from "./shared/service/onesignal.service";
import {UserService} from "./shared/service/user.service";
import {NavigationService} from "./shared/service/navigation.service";
import {SocialLoginService} from "./shared/service/social-login.service";
import {environment} from "../environments/environment";
import {SERVICE_ITEMS, ServiceItemVO} from "./shared/components/service-box-container/items.const";
import * as _ from 'lodash';
import {WasteService} from "./shared/service/waste.service";
import {ContactDrawerComponent} from "./shared/components/contact-drawer/contact-drawer.component";
import {serviceSectionType} from "./shared/types/types";
import {ConsentModalComponent} from "./shared/components/consent-modal/consent-modal.component";
import {animate, style, transition, trigger} from '@angular/animations';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
  animations: [
    trigger('fadeInOut', [
      transition(':leave', [
        animate('350ms ease-out', style({ opacity: 0 }))
      ])
    ])
  ]
})
export class AppComponent implements OnInit {

  @ViewChild('positionDrawer') positionDrawer: DrawerModalComponent;
  @ViewChild('contactDrawer') contactDrawer: ContactDrawerComponent;
  @ViewChild(IonRouterOutlet, { static: true }) routerOutlet: IonRouterOutlet;

  sectionKeys: string[] = [];
  groupped = {};

  isMobileWeb: boolean;
  isStage: boolean;
  showMainLoader: boolean;
  showTransparentLoader: boolean;
  ignoreAlertPosition: boolean;
  lottieOptions: AnimationOptions = {
    path: './assets/lottie/spinner_main.json'
  };

  constructor(private commonService: CommonService,
              private firebaseService: FirebaseService,
              private modalCtrl: ModalController,
              private platform: Platform,
              private activatedRoute: ActivatedRoute,
              private router: Router,
              private navController: NavController,
              protected userService: UserService,
              protected menuCtrl: MenuController,
              private onesignalService: OnesignalService,
              private navigationService: NavigationService,
              private wasteService: WasteService,
              private socialLoginService: SocialLoginService,
              private zone: NgZone,
              private languageService: LanguageService) {

    this.groupped = _.groupBy(SERVICE_ITEMS, 'sectionId');
    this.commonService.profileType = 'cittadino';

    const keys = Object.keys(this.groupped);

    //Verifico le key attive per il tipo di profilo
    for(let key of keys) {

      this.groupped[key] = this.groupped[key]?.filter(this._isActiveMenuItem.bind(this));
      if(this.groupped[key]?.length > 0) {
        this.sectionKeys.push(key);
      }

    }

    this.platform.backButton.subscribeWithPriority(-1, () => {
      if (!this.routerOutlet.canGoBack()) {
        App.exitApp();
      }
    });

    App.addListener('appUrlOpen', (event: URLOpenListenerEvent) => {
      this.zone.run(() => {
        this.navController.navigateForward(event.url.replace('https://andriasmart.fivelab.it', ''));
      });
    });

  }

  onDownloadApp(){
    this.commonService.openStoreLink();
  }

  async ngOnInit() {

    this.isStage = CommonService.isStage();
    this._readRouteEvents();

    this.platform.ready().then(async () => {

      this.socialLoginService.init().then();

      this.isMobileWeb = this.platform.is('mobileweb') && environment.production;

      await this.commonService.presentMobileViewAdvice();

      this.onesignalService.initOneSignal(this.userService.user?.id?.toString());

      const isAndroid = this.commonService.isAndroid();

      if (isAndroid) {

        App.addListener('backButton', () => {
          if (!this.navigationService.canGoBack()) {
            App.exitApp();
          }
        });


      }

      this._initTrack();
      setTimeout(() => {
        //SplashScreen.hide();
      }, 2000); // Mostra per almeno 2 secondi

    });

    moment.locale('it');

    const setStatusBarStyleDark = async () => {
      await StatusBar.setStyle({style: Style.Dark});
    };

    this.languageService.init();

    // Show the splash for two seconds and then automatically hide it:
    await SplashScreen.show({
      showDuration: 3100,
      autoHide: true,
    });

    this.commonService.changeMainLoader.subscribe((value) => {
      this.showMainLoader = value;
    });

    this.commonService.changeTransparentLoader.subscribe((value) => {
      this.showTransparentLoader = value;
    });

    this.commonService.openContactDrawer.subscribe((value) => {
      this.contactDrawer.open();
    });

  }

  onIgnore() {
    localStorage.setItem('ignore_position_alert', '1');
    this.positionDrawer.close();
  }

  async onOpenPositionPermission() {
    //this.positionDrawer.close();
  }

  onLogin(){
    this.navigationService.openPagesModal('login');
    this.menuCtrl.close();
  }

  onNavigateProfile(){
    this.router.navigate(['/settings']);
    this.menuCtrl.close();
  }

  onActionMenuItem(id: serviceSectionType, link: string){
    this.navigationService.onOpenSection(id, this.wasteService.hasUserZone, link);
  }

  private _readRouteEvents() {

    this.router.events
    .pipe(filter(event => event instanceof NavigationEnd))
    .subscribe(() => {
      const currentRoute = this.getChild(this.activatedRoute);
      currentRoute.data.subscribe(data => {
        this.ignoreAlertPosition = !!data['ignoreAlertPosition'];
        //this._openDrawerLocation();
      });
    });

  }

  getChild(route: ActivatedRoute): ActivatedRoute {
    while (route.firstChild) {
      route = route.firstChild;
    }
    return route;
  }

  private _isActiveMenuItem(item: ServiceItemVO) {
    return item.profile == 'all' || item.profile == this.commonService.profileType;
  }

  private _initTrack() {

    const presentConsentModal = async () => {

      const modal = await this.modalCtrl.create({
        component: ConsentModalComponent,
        breakpoints: [0, 0.58],   // 1 = tutta altezza, se vuoi permetterlo
        initialBreakpoint: 0.58,     // parte da qui
        backdropDismiss: false,     // non chiudibile toccando fuori
      });

      modal.present();

      const {data} = await modal.onWillDismiss();
      // data = { analytics: true/false }

      await this.firebaseService.setConsent(data?.analytics);

      if (data?.analytics) {
        this.firebaseService.init();
      }
    };

    const manageTrackConsent = async () => {

      // 1. carica il consenso salvato (se esiste)
      await this.firebaseService.loadConsent();

      // 2. se l'utente ha già acconsentito in precedenza, inizializza subito
      if (this.firebaseService.hasAnalyticsConsent()) {
        this.firebaseService.init();
      }

      // 3. se non ha mai risposto, mostra la modale
      if (this.firebaseService.shouldShowConsentModal()) {
        presentConsentModal();
      }
    };

    if(!environment.debugFirebase){
      manageTrackConsent();
    } else {
      console.log('[FirebaseAnalytics] debug attivo - ', environment.debugFirebase);
    }


  }

  protected readonly slideTransition = slideTransition;
}
